import { render, staticRenderFns } from "./ClimateOnlinePromoSmall.vue?vue&type=template&id=27fb3a95"
import script from "./ClimateOnlinePromoSmall.vue?vue&type=script&lang=js"
export * from "./ClimateOnlinePromoSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports